/*
 * Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { isString } from "utils/empty-exists";
import { ModelValidator } from "./model.validator";
import { excludeSchema } from "./transformers/exclude-schema";
import { mergeFields } from "./transformers/merge-fields";
import { transformModelPayload } from "./transformers/model-payload";
import { migrateBannerimage } from "data/dto/model/transformers/migrate-banner-image";
import { Logger, green, yellowBright } from "cms/utils/log/logger";
import { removeAuditDates } from "data/dto/model/transformers/remove-audit-dates";
import Config from "../../config";

/**
 * Creates an update model payload to send to the API
 * It can probably be refactored to a class
 * @param {object} model 
 * @param {object} update
 * @param {object=} update.field
 * @param {string=} update.title
 * @param {string=} update.description
 * @returns {object}
 */
export function UpdateModelDto (model, update) {
    const TAG = "[UpdateModelDto]";
    
    if (Config.Logging.enableSavePipelineLog) {
        Logger.info(green("[UpdateModelDto] start..."), { model, update });
    }
    
    // update is an object with a field attribute. 
    // This represents a change to one field. 
    const field = update?.field ?? {};
    const title = update?.title;
    const description = update?.description;
    
    // transform the model into an acceptable shape (removes extraneous)
    const payload = transformModelPayload(model);
    
    // we could technically merge in anything here, but this construction is explicit
    if (isString(title)) {
        payload.title = title;
    }
    
    if (isString(description)) {
        payload.description = description;
    }

    const fields = mergeFields(field, model.fields);
    if (Config.Logging.enableSavePipelineLog) {
        Logger.info(yellowBright(`${TAG} mergeFields`), { fields });
    }
    payload.fields = fields;
    
    // fix cases where content is using old name for banner_image (banner-image)
    migrateBannerimage(payload);
    
    removeAuditDates(payload);
    
    const filteredPayload = excludeSchema(payload);
    
    // validate the model against a set of rules
    // FIXME: this is not validating the fields
    // FIXME: provide a way to return errors, or also validate before update
    
    ModelValidator(payload);
    
    return filteredPayload;
}
